import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { map } from 'lodash-es';
import FileNode from 'pages/uploadPage/uploadFolder/tree/fileNode';
import { FolderNodeModel } from 'pages/uploadPage/uploadFolder/tree/folderNodeModel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconFolder from 'shared/icons/iconFolder';
import IconTrash from 'shared/icons/trash';
import { makeTransition } from 'shared/lib/utils/utils';

const startPadding = 4;
const paddingStep = 14;

export default function FolderNodeComponent({
  model,
  onDelete,
  level,
}: {
  model: FolderNodeModel;
  onDelete: () => void;
  level: number;
}) {
  const theme = useTheme();

  return (
    <Accordion
      sx={{ display: 'flex', flexDirection: 'column', width: 1 }}
      defaultExpanded
    >
      <AccordionSummary
        sx={{
          'flexDirection': 'row-reverse',
          'pl': level + startPadding,
          'width': 1,
          'transition': makeTransition(['opacity']),
          '& .MuiIconButton-root': {
            opacity: 0,
            pointerEvents: 'none',
          },
          '&:hover .MuiIconButton-root': {
            opacity: 1,
            pointerEvents: 'all',
          },
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            gap: 2,
          },
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <IconFolder isAutoscallable={false} sizeKey="32x32"></IconFolder>
        <Typography sx={{ whiteSpace: 'nowrap' }}>{model.name}</Typography>
        <IconButton sx={{ flexShrink: 0 }} onClick={onDelete}>
          <IconTrash extColor={theme.palette.error.main}></IconTrash>
        </IconButton>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {map(model.folders, (folder) => {
          return (
            <FolderNodeComponent
              onDelete={() => {
                model.deleteFolder(folder.name);
              }}
              level={level + paddingStep}
              key={folder.name}
              model={folder}
            ></FolderNodeComponent>
          );
        })}
        {map(model.files, (file) => {
          return (
            <FileNode
              onDelete={() => {
                model.deleteFile(file.name);
              }}
              left={level + paddingStep}
              key={file.name}
              file={file}
            ></FileNode>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
}
